import React from "react";
import RBPageCotainer from "./RBPageContainer";
import RBMenuElement from "./MenuElement";
import { catalogitems } from "./menuItems";
import { motion } from 'framer-motion';

const RBCatalog = () => {
  return (
    <RBPageCotainer>
      <div className="row px-3">
        {catalogitems.map((item, index) => {
          let alignmentClass = "";
          if (index % 3 === 0) {
            alignmentClass = "justify-content-start";
          } else if (index % 3 === 1) {
            alignmentClass = "justify-content-center";
          } else {
            alignmentClass = "justify-content-end";
          }

          const delay = index * 0.2; 

          return (
            <motion.div
              key={index}
              className={`col-4 d-flex ${alignmentClass} px-0`}
              initial={{ opacity: 0, y: -50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay }}
            >
              <RBMenuElement item={item} noMargin={true} />
            </motion.div>
          );
        })}
      </div>
    </RBPageCotainer>
  );
};

export default RBCatalog;
